import isEmail from 'validator/lib/isEmail';

export const emailFormatStrategy = (value: string) => {
  return isEmail(value);
};
